import { render, staticRenderFns } from "./AtomLocationType.vue?vue&type=template&id=1dc9d953&"
import script from "./AtomLocationType.vue?vue&type=script&lang=js&"
export * from "./AtomLocationType.vue?vue&type=script&lang=js&"
import style0 from "./AtomLocationType.vue?vue&type=style&index=0&id=1dc9d953&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default})
